import React from 'react';
import styled from 'App/styled';
import Wishlist from '@nykaa/product-card-desktop/components/CardActions/AddToWishlist';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import ActionWrapper from 'components/CardAction';
import { ProductRenderProps } from 'types/product';
import { redirectAuthPage } from 'helpers/auth';
import { selectCurrentSku } from 'store/product/selector';
import { ProductTrackingData } from 'shared/helpers/impressions/types';
import useShouldDisableCta from 'hooks/Product/action';

const Wrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.spacing120};
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
  align-self: flex-end;

  & > button {
    width: auto;
    height: auto;
    border: none;
  }
`;
interface WishlistIconProps {
  pageLocation: string;
  customWishlistClass?: string;
  videoId?: string;
  productTrackingData?: ProductTrackingData;
}
const WishlistIcon = (props: WishlistIconProps) => {
  const { pageLocation, customWishlistClass, videoId, productTrackingData } =
    props;
  const product = useSelector((state: State) => selectCurrentSku(state));
  const { earlyAccessData } = product || {};
  const { disablePriveProduct } = earlyAccessData || {};
  const disableCta = useShouldDisableCta();

  const user = useSelector((state: State) => state.auth?.user);
  return (
    <Wrapper>
      <ActionWrapper
        productTrackingData={productTrackingData}
        isAnalyticsTrackingEnabled
      >
        {({ handleWishlist }: ProductRenderProps) => (
          <Wishlist
            pageLocation={{ pageType: pageLocation }}
            user={user}
            wishlistCallback={handleWishlist}
            redirectAuthPage={redirectAuthPage}
            product={product}
            customWishlistClass={customWishlistClass}
            videoId={videoId}
            isDisabled={disablePriveProduct && disableCta}
          />
        )}
      </ActionWrapper>
    </Wrapper>
  );
};

export default WishlistIcon;
